import { render } from "./Parcours.vue?vue&type=template&id=37e862a2"
import script from "./Parcours.vue?vue&type=script&lang=js"
export * from "./Parcours.vue?vue&type=script&lang=js"

import "./Parcours.vue?vue&type=style&index=0&id=37e862a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__